import { Logger } from '~~/helpers/logger';
import { useProductApi } from '~/utils/ct/composables/api/useProductApi';
import type { ApiParams, GraphQLProductResponse } from '~~/types/commercetools';
import { errorToString } from '~~/helpers/error/errorToString';

export function useProduct<ProductType>(id: string) {

  type ProductsState = { data: GraphQLProductResponse<ProductType> } | null;

  const { search: apiSearch } = useProductApi();

  const products = useState<ProductsState>(
    `useProductProducts-${id}`,
    () => null,
  );
  const loading = useState<boolean>(`useProductLoading-${id}`, () => false);
  const error = useState<{
    search: null | string
  }>(`useProductError-${id}`, () => ({
    search: null,
  }));

  async function search(searchParams: ApiParams) {

    try {

      loading.value = true;

      products.value = await apiSearch<ProductsState>(searchParams);
      error.value.search = null;
    
    } catch (err: unknown) {

      error.value.search = errorToString(err);
      Logger.error(`useProduct.search id:${id}`, err);
    
    } finally {

      loading.value = false;
    
    }
  
  }

  return {
    search,
    products: computed(() => products.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
  };

}
